module.exports = __webpack_public_path__ + "img/card-5.64c7b2d1.png";